export const canOpenURL = href => /https?/gi.test(href || '')